import React, { useState, useRef } from "react";
import { Accordion, Form, Row, Col, Button, Badge } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import UtilMethods from "../../util/UtilMethods";
import { GENDER_OPTIONS, RELATION_OPTIONS } from "../common/Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import {
  faCheckCircle,
  faUsers,
  faUser,
  faEdit,
  faSave,
  faTimesCircle,
  faTrash,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

const GroupMembersAccordion = ({
  groupInfo,
  isEditEnabled,
  handleMemberChange,
  handleDeleteMember,
  handleAddMember,
  editingMemberIndex,
  setEditingMemberIndex,
  setGroupInfo,
}) => {
  const [validationErrors, setValidationErrors] = useState({});

  const validationSchema = {
    firstName: { required: true, type: "text" },
    lastName: { required: true, type: "text" },
    age: { required: true, type: "number" },
    email: { required: false, type: "email" },
    phone: { required: false, type: "phone" },
    gender: { required: true, type: "text" },
    relation: { required: true, type: "text" },
  };

  useEffect(() => {
    //console.log("GroupMembersAccordion useEffect called");
   // UtilMethods.log("info","GroupMembersAccordion useEffect", "isEditEnabled", isEditEnabled, "groupInfo.groupMembers.length", groupInfo.groupMembers.length, "editingMemberIndex", editingMemberIndex);

    // Use groupInfo.groupMembers.length as a dependency instead of the whole array to avoid infinite loops
    if (isEditEnabled && (groupInfo.groupMembers?.length > 0)) {
      if (editingMemberIndex === null || editingMemberIndex === undefined || editingMemberIndex === "") {
        //console.log("Setting editingMemberIndex to 0 in useEffect :", editingMemberIndex);
        setEditingMemberIndex(0);
      } else {
        //  console.log("Us Effect Editing Member Index is already set to:", editingMemberIndex);
      }

      // Populate data for the first member, if in guest mode
      if (
        (!groupInfo.registrationID || groupInfo.registrationID === "") &&
        groupInfo.groupMembers.length === 1 &&
        !groupInfo.groupMembers[0].isEdited
      ) {
        const updatedMember = {
          ...groupInfo.groupMembers[0],
          firstName: groupInfo.firstName || "",
          lastName: groupInfo.lastName || "",
          email: groupInfo.email || "",
          phone: groupInfo.phone || "",
          age: "0",
          gender: "",
          relation: "Myself",
          comments: "",
          isEdited: false,
          deleted: false,
        };
        setGroupInfo(prev => {
          const updatedGroupMembers = [...prev.groupMembers];
          updatedGroupMembers[0] = updatedMember;
          return { ...prev, groupMembers: updatedGroupMembers };
        });
      }
    }
  }, [
    isEditEnabled,
    groupInfo.groupMembers.length,
    groupInfo.registrationID,
    groupInfo.firstName,
    groupInfo.lastName,
    groupInfo.email,
    groupInfo.phone,
    editingMemberIndex,
    setEditingMemberIndex,
    setGroupInfo
  ]); // Dependency array includes only necessary dependencies

  const validateField = (label, value, type, isRequired) => {
    if (isRequired && (!value || String(value).trim() === "")) {
      return `${label} is required.`;
    }
    if (type === "email" && value && !UtilMethods.validateEmail(value)) {
      return "Invalid email address.";
    }
    if (type === "phone" && value && !UtilMethods.validatePhone(value)) {
      return "Invalid phone number.";
    }
    if (type === "number" && value && isNaN(Number(value)) && value !== "") {
      return `${label} must be a number.`;
    }
    if (label.toLowerCase() === "age" && value && Number(value) <= 0) {
      return `${label} must be greater than or equal to 1.`;
    }
    return null;
  };

  const validateMember = (member) => {
    const errors = {};
    Object.keys(validationSchema).forEach((key) => {
      const { required, type } = validationSchema[key];
      const error = validateField(
        key.charAt(0).toUpperCase() + key.slice(1),
        member[key],
        type,
        required
      );
      if (error) errors[key] = error;
    });
    return errors;
  };

  const validateAllMembers = () => {
    const errorsArray = groupInfo.groupMembers.map(validateMember);
    const errorsObject = errorsArray.reduce((acc, error, index) => {
      if (Object.keys(error).length > 0) {
        acc[index] = error;
      }
      return acc;
    }, {});
    setValidationErrors(errorsObject);
    return Object.keys(errorsObject).length === 0;
  };

  const handleEditClick = (index) => {
    if (editingMemberIndex === index) {
      const errors = validateMember(groupInfo.groupMembers[index]);
      if (Object.keys(errors).length > 0) {
        setValidationErrors((prev) => ({ ...prev, [index]: errors }));
        return;
      }
      const updatedMembers = [...groupInfo.groupMembers];
      updatedMembers[index].isEdited = true;
      handleMemberChange(index, "isEdited", true);
    }
    // Update the editingMemberIndex only if it's different from the current one
    const newIndex = index === editingMemberIndex ? null : index;
    //console.log("****** handleEditClick newIndex", newIndex);
    setEditingMemberIndex(newIndex);
    // console.log(" 222 handleEditClick editingMemberIndex ", editingMemberIndex);
  };

  const handleAddEdit = (index) => {
    console.log("handleAddEdit", index);
    if (!validateAllMembers()) {
      return;
    }
    handleAddMember();
    setEditingMemberIndex(index + 1);
  };

  const handleFieldChange = (index, field, value) => {
    //console.log("handleFieldChange", index, field, value);
    handleMemberChange(index, field, value);
    const member = { ...groupInfo.groupMembers[index], [field]: value };
    const errors = validateMember(member);
    setValidationErrors((prev) => ({ ...prev, [index]: errors }));
    //console.log("handleFieldChange", validationErrors);
  };
  const onAccordionHeaderClick = () => {
    //console.log("Member Accordion header clicked");
    //console.log("Member Accordion Editing Member Index before reset:", editingMemberIndex);
    // Reset editing index when accordion header is clicked
    if (editingMemberIndex === null || editingMemberIndex === undefined || editingMemberIndex === "") {
      setEditingMemberIndex(0); 
      //console.log("onAccordionHeaderClick : Resetting editing member index to 0");
    }
    //console.log("Member Accordion Editing Member Index after reset:", editingMemberIndex);
  };

  const renderFormField = (props) => {
    const {
      label,
      value,
      readOnly,
      type = "text",
      options,
      isPhone = false,
      required = false,
      onChange,
      validationError,
    } = props;

    if (readOnly || !isEditEnabled) {
      return (
        <Col md={3}>
          <Form.Group>
            <Form.Label>
              {label}
              {" : "}
            </Form.Label>
            <span>{value}</span>
          </Form.Group>
        </Col>
      );
    }

    return (
      <Col md={3}>
        <Form.Group>
          <Form.Label>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Form.Label>
          {isPhone ? (
            <div
              style={{
                border: "1px solid #dad5ce",
                borderRadius: "10px",
              }}
            >
              <PhoneInput
                defaultCountry="US"
                international
                flagUrl="https://flagcdn.com/w320/{xx}.png"
                value={value}
                onChange={onChange}
                className={`form-select ${validationError ? "is-invalid" : ""}`}
              />
            </div>
          ) : options ? (
            <Form.Select
              as="select"
              value={value}
              onChange={onChange}
              isInvalid={!!validationError}
            >
              {options.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Form.Select>
          ) : (
            <Form.Control
              type={type}
              value={value}
              onChange={onChange}
              isInvalid={!!validationError}
            />
          )}
          {validationError && (
            <Form.Control.Feedback type="invalid">
              {validationError}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    );
  };

  return (
    <Accordion.Item eventKey="2">
      <Accordion.Header >
        <h4>
          <FontAwesomeIcon icon={faUsers} className="me-2" />
          Participants | Count: {groupInfo.numberOfParticipants} | Amount:{" "}
          {groupInfo.amount}
          {Object.keys(validationErrors).filter(
            (key) => Object.keys(validationErrors[key]).length > 0
          ).length > 0 && (
            <Badge>
              {
                Object.keys(validationErrors).filter(
                  (key) => Object.keys(validationErrors[key]).length > 0
                ).length
              }{" "}
              Invalid Members
            </Badge>
          )}
        </h4>
      </Accordion.Header>
      <Accordion.Body>
        <p style={{ textAlign: "center" }}>
          <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
            {"Matthew 22:14 Many are invited, but few are chosen."}
          </span>
        </p>

        {groupInfo.groupMembers.map((member, index) => (
          <div key={index} className="mb-4">
            <h5>
              <FontAwesomeIcon icon={faUser} className="me-2" />
              Member {member.memberID}
              {validationErrors[index] &&
                Object.keys(validationErrors[index]).length > 0 && (
                  <Badge bg="warning" className="ms-2">
                    Invalid
                  </Badge>
                )}
            </h5>
            <Form>
              <Row className="mb-3">
                {["firstName", "lastName", "email", "phone"].map((field) => (
                  <React.Fragment key={field}>
                    {renderFormField({
                      label: field
                        .charAt(0)
                        .toUpperCase()
                        .concat(field.slice(1)),
                      value: member[field],
                      readOnly: editingMemberIndex !== index,
                      type: field === "email" ? "email" : "text",
                      isPhone: field === "phone",
                      required: validationSchema[field]?.required,
                      onChange: (e) =>
                        handleFieldChange(
                          index,
                          field,
                          field === "phone" ? e : e.target.value
                        ),
                      validationError: validationErrors[index]?.[field],
                    })}
                  </React.Fragment>
                ))}
              </Row>
              <Row className="mb-3">
                {["age"].map((field) => (
                  <React.Fragment key={field}>
                    {renderFormField({
                      label: field
                        .charAt(0)
                        .toUpperCase()
                        .concat(field.slice(1)),
                      value: member[field],
                      readOnly: editingMemberIndex !== index,
                      type: "number",
                      required: validationSchema[field]?.required,
                      onChange: (e) =>
                        handleFieldChange(index, field, e.target.value),
                      validationError: validationErrors[index]?.[field],
                    })}
                  </React.Fragment>
                ))}
                {["gender", "relation"].map((field) => (
                  <React.Fragment key={field}>
                    {renderFormField({
                      label: field
                        .charAt(0)
                        .toUpperCase()
                        .concat(field.slice(1)),
                      value: member[field],
                      readOnly: editingMemberIndex !== index,
                      type: "text",
                      options:
                        field === "gender"
                          ? GENDER_OPTIONS
                          : field === "relation"
                          ? RELATION_OPTIONS
                          : null,
                      required: validationSchema[field]?.required,
                      onChange: (e) =>
                        handleFieldChange(index, field, e.target.value),
                      validationError: validationErrors[index]?.[field],
                    })}
                  </React.Fragment>
                ))}
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>{"Status : "}</Form.Label>
                    {editingMemberIndex === index && <br />}
                    {member.deleted ? (
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        style={{ color: "red" }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        style={{ color: "green" }}
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Remarks : </Form.Label>
                    {editingMemberIndex !== index ? (
                      <label>{member.comments || "N/A"}</label>
                    ) : (
                      <Form.Control
                        as="textarea"
                        value={member.comments}
                        onChange={(e) =>
                          handleFieldChange(index, "comments", e.target.value)
                        }
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Button
                variant="secondary"
                onClick={() => handleEditClick(index)}
                disabled={!isEditEnabled}
              >
                <FontAwesomeIcon
                  icon={editingMemberIndex === index ? faSave : faEdit}
                  className="me-2"
                />
                {editingMemberIndex === index ? "Update" : "Edit"}
              </Button>
              <Button
                variant={member.deleted ? "warning" : "danger"}
                disabled={!isEditEnabled}
                onClick={() => handleDeleteMember(index, !member.deleted)}
                className="ms-2"
              >
                <FontAwesomeIcon
                  icon={member.deleted ? faTimesCircle : faTrash}
                  className="me-2"
                />
                {member.deleted ? "Undo Delete" : "Delete"}
              </Button>
              {(index === groupInfo.groupMembers.length - 1 ||
                groupInfo.groupMembers.length === 0) && (
                <Button
                  variant="success"
                  disabled={!isEditEnabled}
                  onClick={() => handleAddEdit(index)}
                  className="ms-2"
                >
                  <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                  Add Member
                </Button>
              )}
            </Form>
          </div>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default GroupMembersAccordion;
